import { InternalRatesManager } from "@/components/admin/InternalRatesManager";
import { StepUpGate } from "@/components/admin/StepUpGate";

export function SettingsInternalRatesPage() {
  return (
    <StepUpGate>
      {(stepUpId, onExpired) => <InternalRatesManager stepUpId={stepUpId} onExpired={onExpired} />}
    </StepUpGate>
  );
}
